import React from 'react';
import './KPICards.css';
import HelpTooltip from '../HelpTooltip/HelpTooltip';

/**
 * KPICards — Reusable animated metric card strip.
 * Used by both DashboardWindow and PromotionalWindow.
 *
 * @param {Array} cards - Array of { label, value, sub, icon, color, trend, trendLabel, tooltip }
 */
const KPICards = ({ cards = [] }) => {
  if (!cards || cards.length === 0) return null;

  return (
    <div className="kpi-strip">
      {cards.map((card, idx) => (
        <div
          key={idx}
          className={`kpi-card kpi-${card.color || 'blue'} ${card.onClick ? 'kpi-card-clickable' : ''}`}
          role={card.onClick ? 'button' : undefined}
          tabIndex={card.onClick ? 0 : undefined}
          title={card.onClick ? 'Click to view model performance details' : undefined}
          onClick={card.onClick}
          onKeyDown={(event) => {
            if (!card.onClick) return;
            if (event.key === 'Enter' || event.key === ' ') {
              event.preventDefault();
              card.onClick();
            }
          }}
        >
          <div className="kpi-icon">{card.icon}</div>
          <div className="kpi-body">
            <div className="kpi-value">{card.value}</div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
              <div className="kpi-label">{card.label}</div>
              {card.tooltip && (
                <HelpTooltip 
                  title={card.tooltip.title} 
                  content={card.tooltip.content} 
                />
              )}
            </div>
            {card.sub && <div className="kpi-sub">{card.sub}</div>}
          </div>
          {card.trend !== undefined && (
            <div className={`kpi-trend ${card.trend >= 0 ? 'trend-up' : 'trend-down'}`}>
              <span className="trend-arrow">{card.trend >= 0 ? '↑' : '↓'}</span>
              <span className="trend-val">{Math.abs(card.trend).toFixed(1)}%</span>
              {card.trendLabel && <span className="trend-label">{card.trendLabel}</span>}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default KPICards;
